import { checkWidth, checkHeight } from '../utilities/utility';
import { formPost } from '../components/ajax';
import { API_REFERENCE } from '../utilities/constant_api';
$(function() {
  const commUpdatePrefUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.communicationsPreferences.communicationsPreferencesUpdate}`;
  const smsPopupCheckRow = '.comm-pref-sms-check';
  let smsPopupSelectedChecboxObjValue = '';
  function commPrefConfirmSelection(e) {
    const thisChecboxEle = smsPopupSelectedChecboxObjValue;
    callAjaxForCommPref(thisChecboxEle.val(), false);
    ACC.colorbox.close();
    setTimeout(() => {
      if (
        smsPopupSelectedChecboxObjValue.closest(smsPopupCheckRow).length > 0
      ) {
        smsPopupSelectedChecboxObjValue.prop('disabled', true);
      }
      smsPopupSelectedChecboxObjValue.prop('checked', false);
    }, 500);
  }

  function commPrefCancelSelection(e) {
    if (smsPopupSelectedChecboxObjValue.closest(smsPopupCheckRow).length > 0) {
      smsPopupSelectedChecboxObjValue.removeAttr('disabled');
    }
    smsPopupSelectedChecboxObjValue.prop('checked', true);
    ACC.colorbox.close();
  }

  function callAjaxForCommPref(id, checkedVal) {
    let token = id.split('_');
    const reqCategoryRefDetailId = token[0];
    const personCommPreferId = token[1];
    const flagType = token[2];
    const flagValue = checkedVal;
    const requestData = {
      subCategoryRefDetailId: reqCategoryRefDetailId,
      personCommPreferId: personCommPreferId,
      flagType: flagType,
      flagValue: flagValue
    };
    const requestUrl = commUpdatePrefUrl;
    $('.generic-error-container').addClass('hidden');
    formPost(requestUrl, requestData).then(response => {
      if (response !== '200 OK') {
        $('.generic-error-container .generic-error-text').text(response);
        $('.generic-error-container').removeClass('hidden');
        window.scrollTo(0, 0);
      }
    });
  }

  function modalTrigger(thisObj, id, checkedVal) {
    const checkboxes = $('.order-reminders').find('.custom-checkbox:checked')
      .length;
    smsPopupSelectedChecboxObjValue = $(thisObj);
    if (checkboxes < 1) {
      if (!checkedVal) {
        ACC.colorbox.open('', {
          html: $('.confirmation-modal').html(),
          onLoad: $('#cboxOverlay').css('position', 'fixed'),
          width: checkWidth(),
          height: checkHeight(),
          title: $('.confirmation-modal-header #modalLabel').text(),
          className: 'communication-pref-modal',
          onClosed: function() {
            commPrefCancelSelection();
          }
        });
        $('.communication-pref-modal .ok-btn').on(
          'click',
          commPrefConfirmSelection
        );
        $('.footer-btns .cancel-btn,.communication-pref-modal #cboxClose').on(
          'click',
          commPrefCancelSelection
        );
      }
    } else {
      callAjaxForCommPref(id, checkedVal);
    }
  }

  function setCommPref(e) {
    const checkedEle = $(e.target);
    let checkedVal = false;
    let id;
    if (
      checkedEle.closest('.comm-pref-sms-check').length > 0 &&
      !checkedEle.is(':checked')
    ) {
      checkedEle.prop('disabled', true);
    }
    if (checkedEle.is(':checked')) {
      checkedVal = true;
    }
    id = checkedEle.val();
    const token = id.split('_');
    const reqCatType = token[3];
    if (reqCatType === 'order') {
      modalTrigger(this, id, checkedVal);
    } else {
      callAjaxForCommPref(id, checkedVal);
    }
  }

  function initCommPreferences() {
    if ($('.communication-preferences-list-view').length) {
      $('.communication-preferences-list-view')
        .find('table tbody tr:last')
        .addClass('comm-pref-remove-border-bottom');
    }
  }
  initCommPreferences();
  $(document).on(
    'click',
    '.account-settings-view .custom-checkbox',
    setCommPref
  );
});
